export default {
    POST: {texto: 'Post', valor: 'POST'},
    GET: {texto: 'Get', valor: 'GET'},
    PUT: {texto: 'Put', valor: 'PUT'},
    DELETE: {texto: 'Delete', valor: 'DELETE'}
}
